export { default } from './EducationSystem.jsx';
